import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import {
  currentPageAtom,
  filterApiPayloadWithoutPageParamAtom,
  isQuerySynchronizationDoneAtom,
} from '../Filter/filterStore';

export default function useResetPageOnFilterPayloadChange() {
  const filterApiPayloadWithoutPageParam = useAtomValue(filterApiPayloadWithoutPageParamAtom);
  const setCurrentPage = useSetAtom(currentPageAtom);
  const isQuerySynchronizationDone = useAtomValue(isQuerySynchronizationDoneAtom);

  useEffect(() => {
    if (!isQuerySynchronizationDone) return;

    setCurrentPage(1);
  }, [filterApiPayloadWithoutPageParam]);
}
